import React from "react";
import styled from "styled-components";
import { media } from "../Utils/media";
import topTest from "../Assets/Images/topTest.svg";
import instaTest from "../Assets/Images/instaTest.svg";
import kakaoTest from "../Assets/Images/kakaoTest.svg";
import linkedTest from "../Assets/Images/linkedTest.svg";
import youtubeTest from "../Assets/Images/youtubeTest.svg";
import { fluidFont } from "../Utils/fontSize";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // 부드러운 스크롤
    });
  };

  const openLink = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  return (
    <FooterContainer>
      <FooterArea>
        <FooterSection1>
          <FooterSection1SubCopy>위대한 꿈을 이루는 선구자, 지디피 스튜디오가 나아갈 길입니다.</FooterSection1SubCopy>
          <FooterSection1TitleCopy>
            G<StrokeText>enerative</StrokeText> D<StrokeText>ocument</StrokeText> P<StrokeText>rocessing</StrokeText>
          </FooterSection1TitleCopy>
          <FooterSection1DataArea>
            <FooterSection1DataItem>
              <FooterSection1DataCopy style={{ marginRight: "12px", fontWeight: "800" }}>회사</FooterSection1DataCopy>
              <FooterSection1DataCopy>GDP Studio Inc.</FooterSection1DataCopy>
            </FooterSection1DataItem>
            <FooterSection1DataItem>
              <FooterSection1DataCopy style={{ marginRight: "12px", fontWeight: "800" }}>대표</FooterSection1DataCopy>
              <FooterSection1DataCopy>이유</FooterSection1DataCopy>
            </FooterSection1DataItem>
            <FooterSection1DataItem>
              <FooterSection1DataCopy style={{ marginRight: "12px", fontWeight: "800" }}>사업자등록번호</FooterSection1DataCopy>
              <FooterSection1DataCopy>146-87-02284</FooterSection1DataCopy>
            </FooterSection1DataItem>
            <FooterSection1DataItem>
              <FooterSection1DataCopy style={{ marginRight: "12px", fontWeight: "800", minWidth: "24.2px" }}>주소</FooterSection1DataCopy>
              <FooterSection1DataCopy style={{ lineHeight: isMobile ? "1.35" : "1" }}>
                경기도 성남시 분당구 대왕판교로645번길 12,{isMobile && <br />} 경기창조혁신센터 8F R07
              </FooterSection1DataCopy>
            </FooterSection1DataItem>
            <FooterSection1DataItem>
              <FooterSection1DataCopy style={{ marginRight: "12px", fontWeight: "800" }}>전화</FooterSection1DataCopy>
              <FooterSection1DataCopy>010-6212-0225</FooterSection1DataCopy>
            </FooterSection1DataItem>
            <FooterSection1DataItem>
              <FooterSection1DataCopy style={{ marginRight: "12px", fontWeight: "800" }}>이메일</FooterSection1DataCopy>
              <FooterSection1DataCopy>help@certifie.io</FooterSection1DataCopy>
            </FooterSection1DataItem>
            <FooterSection1DataItem>
              <FooterSection1DataCopy style={{ marginRight: "12px", fontWeight: "800" }}>운영시간</FooterSection1DataCopy>
              <FooterSection1DataCopy>평일 : 09:00-18:00</FooterSection1DataCopy>
            </FooterSection1DataItem>
          </FooterSection1DataArea>
        </FooterSection1>
        <FooterSection2>
          <TopButton onClick={scrollToTop}>
            <img src={topTest} alt="topTest" width="100%" />
          </TopButton>
          <FooterLinkArea>
            <FooterLinkButton>
              <img src={instaTest} alt="instaTest" width="100%" />
            </FooterLinkButton>
            <FooterLinkButton>
              <img src={kakaoTest} alt="kakaoTest" width="100%" />
            </FooterLinkButton>
            <FooterLinkButton>
              <img src={linkedTest} alt="linkedTest" width="100%" />
            </FooterLinkButton>
            <FooterLinkButton>
              <img src={youtubeTest} alt="youtubeTest" width="100%" />
            </FooterLinkButton>
          </FooterLinkArea>
        </FooterSection2>
        <FooterSection3>ⓒ 2025 GDP Studio Inc. All rights reserved.</FooterSection3>
        <FooterSection4>
          <FooterSection4Link onClick={() => openLink("https://certifie-privacy-policy.vercel.app")}>개인정보처리방침</FooterSection4Link>
          <FooterSection4Link onClick={() => openLink("https://certifie-terms-of-use.vercel.app")}>이용약관</FooterSection4Link>
        </FooterSection4>
      </FooterArea>
    </FooterContainer>
  );
};

const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: #001024;
  box-sizing: border-box;
  ${media.web`
    padding: 130px 120px 80px;
    width: 100%;
    /* min-width: 906px; */
  `}
  ${media.mobile`
    padding: 48px 30px;
    width: 100%;
    /* min-width: 906px; */
  `}
`;

const FooterArea = styled.div`
  display: grid;
  width: 100%;
  ${media.web`
    grid-template-columns: auto 250px;
    max-width: 1720px;
  `}
  ${media.mobile`
    /* grid-template-columns: auto 250px; */
    max-width: 1720px;
  `}
`;

const FooterSection1 = styled.div`
  opacity: 0.8;
  border-bottom: solid 1px rgba(255, 255, 255, 0.15);
  ${media.web`
    padding-bottom: 40px;
    margin-bottom: 40px;
  `}
  ${media.mobile`
    padding-bottom: 20px;
    margin-bottom: 20px;
  `}
`;

const FooterSection1SubCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 500;
  ${media.web`
    font-size: ${fluidFont(16, 24)};
  `}
  ${media.mobile`
    font-size: 14px;
  `}
`;

const FooterSection1TitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  margin-top: 16px;
  ${media.web`
font-size: ${fluidFont(32, 58)};
  `}
  ${media.mobile`
font-size: 32px;
  `}
`;

const FooterSection1DataArea = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  ${media.web`
    max-width: 890px;
    gap: 14px 24px;
    margin-top: 60px;
  `}
  ${media.mobile`
    max-width: 890px;
    gap: 12px 24px;
    margin-top: 30px;
  `}
`;

const FooterSection1DataItem = styled.div`
  display: flex;

  ${media.web`
  `}
`;

const FooterSection1DataCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  ${media.web`
font-size: ${fluidFont(12, 18)};
  `}
  ${media.mobile`
font-size: 14px;
  `}
`;

const FooterSection2 = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  border-bottom: solid 1px rgba(255, 255, 255, 0.15);
  ${media.web`
    align-items: flex-end;
    padding-bottom: 40px;
    margin-bottom: 40px;
  `}
  ${media.mobile`
    align-items: flex-start;
    padding-bottom: 20px;
    margin-bottom: 20px;
  `}
`;

const TopButton = styled.button`
  transition: all 0.4s;
  color: #fff;
  letter-spacing: -0.02em;
  cursor: pointer;
  background: transparent;
  border: none;
  outline: 0;
`;

const FooterLinkArea = styled.div`
  display: flex;
  align-items: center;

  ${media.web`
    gap: 0 24px;
  `}
  ${media.mobile`
    gap: 0 24px;
  `}
`;

const FooterLinkButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  opacity: 0.6;
`;

const FooterSection3 = styled.div`
  color: rgba(255, 255, 255, 0.7);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  ${media.web`
    font-size: ${fluidFont(14, 18)};
  `}
  ${media.mobile`
    font-size: 14px;
  `}
`;

const FooterSection4 = styled.div`
  display: flex;
  align-items: center;

  ${media.web`
    justify-content: flex-end;
    gap: 0 24px;
  `}
  ${media.mobile`
    justify-content: flex-start;
    gap: 0 24px;
    margin-top : 12px;
  `}
`;

const FooterSection4Link = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.7);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  ${media.web`
    font-size: ${fluidFont(14, 18)};
  `}
  ${media.mobile`
    font-size: 14px;
  `}
`;

const StrokeText = styled.span`
  -webkit-text-stroke: 1px #ffffff;
  color: transparent !important;
`;

export default Footer;
